import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';

export interface PariModel {
  user_id?: string;
  event_date?: Date;
  event_name?: string;
  status?: string;
  cote?: number;
  mise?: number;
  nbr_paris?: number;
}

export interface BankrollStats {
  total_mise: number;
  total_gain: number;
  total_perte: number;
  roi: number;
  nb_paris_total: number;
  nb_paris_gagnes: number;
  nb_paris_perdus: number;
  taux_reussite: number;
  bankroll_evolution: Array<{
    date: string;
    capital: number;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class BankrolService {
  private http = inject(HttpClient);
  private BASE_URL = environment.apiUrl + 'api';

  createParis(pari: PariModel, userId: string): Observable<any> {
    const pariData = {
      ...pari,
      user_id: userId
    };
    return this.http.post(`${this.BASE_URL}/bankroll/user/${userId}/bets`, pariData);
  }

  getUserParis(userId: string, period: string = '30'): Observable<any> {
    return this.http.get<any>(`${this.BASE_URL}/bankroll/user/${userId}/bets?period=${period}`);
  }

  updatePari(pariId: number, pari: PariModel): Observable<any> {
    const userId = JSON.parse(localStorage.getItem('user') || '{}').user_id
    return this.http.put(`${this.BASE_URL}/bankroll/user/${userId}/bets/${pariId}`, pari);
  }

  deletePari(pariId: string): Observable<any> {
    const userId = JSON.parse(localStorage.getItem('user') || '{}').user_id
    return this.http.delete(`${this.BASE_URL}/bankroll/user/${userId}/bets/${pariId}`);
  }
  getBankrollStats(userId: string): Observable<BankrollStats> {
    return this.http.get<BankrollStats>(`${this.BASE_URL}/stats/${userId}`);
  }
}